var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 2.9987H26.0003C26.3539 2.9987 26.6931 3.13917 26.9431 3.38922C27.1932 3.63927 27.3337 3.97841 27.3337 4.33203V25.6654C27.3337 26.019 27.1932 26.3581 26.9431 26.6082C26.6931 26.8582 26.3539 26.9987 26.0003 26.9987H2.00033C1.6467 26.9987 1.30756 26.8582 1.05752 26.6082C0.807468 26.3581 0.666992 26.019 0.666992 25.6654V4.33203C0.666992 3.97841 0.807468 3.63927 1.05752 3.38922C1.30756 3.13917 1.6467 2.9987 2.00033 2.9987H7.33366V0.332031H10.0003V2.9987H18.0003V0.332031H20.667V2.9987ZM18.0003 5.66536H10.0003V8.33203H7.33366V5.66536H3.33366V10.9987H24.667V5.66536H20.667V8.33203H18.0003V5.66536ZM24.667 13.6654H3.33366V24.332H24.667V13.6654Z",
    fill: "#806DFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInputIcon);
export default __webpack_public_path__ + "static/media/CalendarInputIcon.f9a7068c9bbbb27534df6d264fc21c35.svg";
export { ForwardRef as ReactComponent };